import { messages as portugueseMessages } from './pt'
import { messages as englishMessages } from './en'
//import { messages as SpaninhMessages } from './es'

const messages = {
    ...portugueseMessages,
    ...englishMessages
    //...SpaninhMessages
}

export { messages }